import React, { useState } from "react";
import NavigationChange from "../../components/NavigationChange";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, Tab } from "@mui/material";
import SafetyNotificationGrid from "./SafetyNotificationGrid";

const SafetyNotificationContainer = () => {
  const [value, setValue] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  return (
    <>
      <div className="Heading">
        <NavigationChange
          Topics={"Alerts"}
          numberofRecord={totalCount}
          back={false}
        />
      </div>
      <div className="row" id="titleWithDropdowns">
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(event, newValue) => setValue(newValue)}
              aria-label="lab API tabs example"
              //   indicatorColor="primary" // Set to "primary" to avoid MUI default overrides
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "green !important", // Forces the indicator to be green
                },
              }}
            >
              <Tab
                label="All"
                value={null}
                style={{
                  color: "black",
                  fontFamily: "Inter",
                  fontWeight: "bolder",
                }}
              />

              <Tab
                label="Service"
                value="service"
                style={{
                  color: "black",
                  fontFamily: "Inter",
                  fontWeight: "bolder",
                }}
              />
              <Tab
                label="Safety"
                value="safety"
                style={{
                  color: "black",
                  fontFamily: "Inter",
                  fontWeight: "bolder",
                }}
              />
            </TabList>
          </Box>
          <TabPanel value={null}>
            <SafetyNotificationGrid
              filterkey={value}
              setTotalCount={setTotalCount}
            />
          </TabPanel>
          <TabPanel value="safety">
            <SafetyNotificationGrid
              filterkey={value}
              setTotalCount={setTotalCount}
            />
          </TabPanel>
          <TabPanel value="service">
            <SafetyNotificationGrid
              filterkey={value}
              setTotalCount={setTotalCount}
            />
          </TabPanel>
        </TabContext>
      </div>
    </>
  );
};

export default SafetyNotificationContainer;
